import styled from "styled-components";
import MayoLogo from "./MayoLogo";
import { useNavigate, useParams } from "react-router-dom";
import { postAnalytics } from "../../../../../PatientComponents/analytics";
import { useEffect, useState } from "react";
import { usePatientFacing } from "../../../../flow/patientFacing/hooks/usePatientFacing";

const LANGUAGES = [
    {
        "name": "English",
        "value": "en"
    },
    {
        "name": "Español",
        "value": "sp"
    },
    {
        "name": "عربيه",
        "value": "ar"
    },
    {
        "name": "Pусский",
        "value": "ru"
    },
]

export default function MayoLanding({
  image,
  title,
  text,
  buttonText,
  navigateTo,
  postAnalyticType,
  incluedTermsOfUse=true,
}) {
  const { getEventDataLocal } = usePatientFacing();
  const event = getEventDataLocal();

  // Handle missing event data (expired or invalid link)
  if (!event) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        textAlign: 'center',
        background: '#f5f5f5'
      }}>
        <div style={{
          background: '#f8f9fa',
          borderRadius: '12px',
          padding: '40px',
          maxWidth: '500px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏰</div>
          <h1 style={{ color: '#dc3545', marginBottom: '16px', fontSize: '24px' }}>Link Expired</h1>
          <p style={{ color: '#6c757d', fontSize: '16px', lineHeight: '1.5' }}>
            This link has expired or is no longer valid.
          </p>
          <p style={{ color: '#6c757d', fontSize: '14px', marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #dee2e6' }}>
            If you have questions about your procedure, please contact your healthcare provider.
          </p>
        </div>
      </div>
    );
  }

  const eventId = event?.id;

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`${navigateTo}/${eventId || ""}`);
  };

  useEffect(() => {
    const caseId = event?.Case?.id;
    if(caseId) {
      postAnalytics({ userId: caseId, type: postAnalyticType });
    }
    else {
      console.error("Invalid Case Id")
    }
  }, [event])

  return (
    (!eventId || event) && // !eventId is added for the demo page
    <Container>
      <MayoLogo style={{marginBottom: 10}}/>
      {/* <GistLanguageBar 
        selectedLanguage={"en"}
        handleSelect={()=>{}}
        languages={LANGUAGES}
      /> */}
      <Image 
        src={image}
      />
      <Title>{title}</Title>
      <Text>{text}</Text>
      <Button 
        onClick={handleNavigate}
      >{buttonText}</Button>
      {incluedTermsOfUse &&
        <LegalText>
          By clicking here you accept our {" "}
          <LegalLink
            onClick={() => navigate("/patient/terms")}
            >
            terms of use
          </LegalLink>
        </LegalText>
      }
    </Container>
  );
}

const Container = styled.div`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(241, 244, 251, 0.5) 25%,
    rgba(227, 232, 246, 0.5) 50%,
    rgba(245, 247, 252, 0.5) 75%,
    rgba(255, 255, 255, 0.5) 100%
  );

  display: flex;
  flex-direction: column;
  align-items: center;

  font-family: Abraham;
  color: #2A2A2A;
`

const Title = styled.p`
  margin: 0;
  text-align: center;
  color: #000000;
  font-size: 22px;
  font-weight: 700;

  margin-top: 24px;
  margin-bottom: 8px;
`

const Text = styled.p`
  margin: 0;
  text-align: center;
  margin-inline: 28px;
  font-size: 18px;
`

const Image = styled.img`
margin-top: 21px;
  margin-inline: 50px;
  width: calc(100% - 100px);
  height: auto;
  display: block;
`

const Button = styled.button`
  margin-top: 28px;
  margin-bottom: 16px;
  border-radius: 29px;
  border: 0;

  background-color: #F02A4C;

  width: 175px;
  height: 43px;
  color: #FFFFFF;
  font-size: 18px;
`

const LegalText = styled.p`
  display: inline-block;
  font-size: 15px;
  margin: 0;
  text-align: center;
  font-family: 'Abraham', Arial, sans-serif;
  font-weight: 400;
  line-height: 19px;
`;

// const LegalLink = styled(Link)`
const LegalLink = styled.span`
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
  font-family: 'Abraham', Arial, sans-serif;
  font-weight: 500;
`;